<template>
  <b-navbar type="light">
    <b-navbar-brand
      href="/"
      class="text-basic-black"
    >
      <span class="logo">
        <img src="@/assets/images/logo_small.png">
      </span>
      admin
    </b-navbar-brand>
  </b-navbar>
</template>

<script>
export default {
  name: 'console-header',
  components: {},
  created () {
  },
  beforeDestroy () {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.navbar {
  padding: 0 0.2rem;
}
.navbar-brand {
  margin-top: -25px;
  height: 90px;
  overflow: hidden;
}
.logo {
  img {
    margin-top: -25px;
    height: 170px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/console/Header.vue